import useExportFile from '../useExportFile';

export default function useExportAliases() {
  const { exportFile, isExporting, error } = useExportFile({
    endpoint: 'alias-sets/current',
    entityName: 'Alias Sets',
  });

  const exportAliases = async (): Promise<boolean> => {
    return exportFile();
  };

  return {
    exportAliases,
    isExporting,
    error,
  };
}
